import script from "./PdfDownloadProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfDownloadProgress.vue?vue&type=script&setup=true&lang=js"

import "./PdfDownloadProgress.vue?vue&type=style&index=0&id=7906e52c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7906e52c"]])

export default __exports__